import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import { CUSTOMER_SUCCESS_EMAIL } from "config/constant";
import { usePosthogSupport } from "hooks/usePosthogSupport";
import { isPosthogConversationsPanelOpen } from "hooks/usePosthogSupport/posthogConversationsDom";
import { getPosthogSupportUnavailableMessage } from "hooks/usePosthogSupport/posthogSupportDiagnostics";

/**
 * Opens or closes the PostHog support chat. When the widget is not ready it
 * shows a plain retry line; the technical diagnostics only go to the console.
 */
export function useSupportChat() {
  const { isOpen, toggle } = usePosthogSupport();
  const [isPending, setIsPending] = useState(false);

  const toggleChat = useCallback(() => {
    if (isPending) {
      return;
    }

    setIsPending(true);
    void toggle()
      .then(async (success) => {
        if (success || isPosthogConversationsPanelOpen()) {
          return;
        }

        // The diagnostics name env vars, localhost ports and the /ph proxy, so they
        // are for us, not the user. Log them and show a plain retry line (RV-1052).
        const diagnosticMessage = await getPosthogSupportUnavailableMessage();
        if (diagnosticMessage) {
          console.warn(`[RivetAI Support] ${diagnosticMessage}`);
        }

        toast.info(
          `Support chat is still loading. Please try again in a moment, or email ${CUSTOMER_SUCCESS_EMAIL}.`
        );
      })
      .finally(() => {
        setIsPending(false);
      });
  }, [isPending, toggle]);

  return { isOpen, isPending, toggleChat };
}
